var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0461 3.77515H4.37948C3.36695 3.77515 2.54614 4.59596 2.54614 5.60848V16.6085C2.54614 17.621 3.36695 18.4418 4.37948 18.4418H19.0461C20.0587 18.4418 20.8795 17.621 20.8795 16.6085V5.60848C20.8795 4.59596 20.0587 3.77515 19.0461 3.77515Z",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8795 6.52515L12.657 11.7501C12.374 11.9275 12.0468 12.0215 11.7128 12.0215C11.3789 12.0215 11.0516 11.9275 10.7686 11.7501L2.54614 6.52515",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEm);
export default __webpack_public_path__ + "static/media/em.3677754847336a0b1b39026e3aca7bf7.svg";
export { ForwardRef as ReactComponent };